// @generated by protoc-gen-es v2.2.2 with parameter "target=ts"
// @generated from file ga/config_manager/providersconfig/providers_config.proto (package ga.config_manager.providersconfig, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv1";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv1";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file ga/config_manager/providersconfig/providers_config.proto.
 */
export const file_ga_config_manager_providersconfig_providers_config: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * @generated from message ga.config_manager.providersconfig.Result
 */
export type Result = Message<"ga.config_manager.providersconfig.Result"> & {
  /**
   * @generated from field: map<string, string> errors = 1;
   */
  errors: { [key: string]: string };

  /**
   * @generated from field: map<string, string> warnings = 2;
   */
  warnings: { [key: string]: string };

  /**
   * @generated from field: map<string, string> infos = 3;
   */
  infos: { [key: string]: string };
};

/**
 * Describes the message ga.config_manager.providersconfig.Result.
 * Use `create(ResultSchema)` to create a new message.
 */
export const ResultSchema: GenMessage<Result> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_providersconfig_providers_config, 0);

/**
 * @generated from message ga.config_manager.providersconfig.ModelsBranchesRequest
 */
export type ModelsBranchesRequest = Message<"ga.config_manager.providersconfig.ModelsBranchesRequest"> & {
};

/**
 * Describes the message ga.config_manager.providersconfig.ModelsBranchesRequest.
 * Use `create(ModelsBranchesRequestSchema)` to create a new message.
 */
export const ModelsBranchesRequestSchema: GenMessage<ModelsBranchesRequest> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_providersconfig_providers_config, 1);

/**
 * @generated from message ga.config_manager.providersconfig.ModelsBranchesResponse
 */
export type ModelsBranchesResponse = Message<"ga.config_manager.providersconfig.ModelsBranchesResponse"> & {
  /**
   * @generated from field: repeated string branches = 1;
   */
  branches: string[];
};

/**
 * Describes the message ga.config_manager.providersconfig.ModelsBranchesResponse.
 * Use `create(ModelsBranchesResponseSchema)` to create a new message.
 */
export const ModelsBranchesResponseSchema: GenMessage<ModelsBranchesResponse> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_providersconfig_providers_config, 2);

/**
 * @generated from message ga.config_manager.providersconfig.ModelsRequest
 */
export type ModelsRequest = Message<"ga.config_manager.providersconfig.ModelsRequest"> & {
  /**
   * @generated from field: string branch = 1;
   */
  branch: string;

  /**
   * optional filter
   *
   * @generated from field: string provider = 2;
   */
  provider: string;
};

/**
 * Describes the message ga.config_manager.providersconfig.ModelsRequest.
 * Use `create(ModelsRequestSchema)` to create a new message.
 */
export const ModelsRequestSchema: GenMessage<ModelsRequest> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_providersconfig_providers_config, 3);

/**
 * @generated from message ga.config_manager.providersconfig.ModelsResponse
 */
export type ModelsResponse = Message<"ga.config_manager.providersconfig.ModelsResponse"> & {
  /**
   * @generated from field: repeated ga.config_manager.providersconfig.ProviderModel models = 1;
   */
  models: ProviderModel[];
};

/**
 * Describes the message ga.config_manager.providersconfig.ModelsResponse.
 * Use `create(ModelsResponseSchema)` to create a new message.
 */
export const ModelsResponseSchema: GenMessage<ModelsResponse> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_providersconfig_providers_config, 4);

/**
 * Mirrors provider_setting_infos row.
 *
 * @generated from message ga.config_manager.providersconfig.ProviderModel
 */
export type ProviderModel = Message<"ga.config_manager.providersconfig.ProviderModel"> & {
  /**
   * @generated from field: string branch = 1;
   */
  branch: string;

  /**
   * @generated from field: string provider = 2;
   */
  provider: string;

  /**
   * @generated from field: ga.config_manager.providersconfig.SettingTable table = 3;
   */
  table: SettingTable;

  /**
   * @generated from field: string setting = 4;
   */
  setting: string;

  /**
   * @generated from field: ga.config_manager.providersconfig.SettingType setting_type = 5;
   */
  settingType: SettingType;

  /**
   * @generated from field: string comment = 6;
   */
  comment: string;

  /**
   * @generated from field: bool required = 7;
   */
  required: boolean;

  /**
   * @generated from field: ga.config_manager.providersconfig.Action action = 16;
   */
  action: Action;
};

/**
 * Describes the message ga.config_manager.providersconfig.ProviderModel.
 * Use `create(ProviderModelSchema)` to create a new message.
 */
export const ProviderModelSchema: GenMessage<ProviderModel> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_providersconfig_providers_config, 5);

/**
 * @generated from message ga.config_manager.providersconfig.CopyModelsBranchRequest
 */
export type CopyModelsBranchRequest = Message<"ga.config_manager.providersconfig.CopyModelsBranchRequest"> & {
  /**
   * @generated from field: string from_branch = 1;
   */
  fromBranch: string;

  /**
   * @generated from field: string to_branch = 2;
   */
  toBranch: string;
};

/**
 * Describes the message ga.config_manager.providersconfig.CopyModelsBranchRequest.
 * Use `create(CopyModelsBranchRequestSchema)` to create a new message.
 */
export const CopyModelsBranchRequestSchema: GenMessage<CopyModelsBranchRequest> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_providersconfig_providers_config, 6);

/**
 * @generated from message ga.config_manager.providersconfig.CopyModelsBranchResponse
 */
export type CopyModelsBranchResponse = Message<"ga.config_manager.providersconfig.CopyModelsBranchResponse"> & {
};

/**
 * Describes the message ga.config_manager.providersconfig.CopyModelsBranchResponse.
 * Use `create(CopyModelsBranchResponseSchema)` to create a new message.
 */
export const CopyModelsBranchResponseSchema: GenMessage<CopyModelsBranchResponse> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_providersconfig_providers_config, 7);

/**
 * @generated from message ga.config_manager.providersconfig.UpsertModelRequest
 */
export type UpsertModelRequest = Message<"ga.config_manager.providersconfig.UpsertModelRequest"> & {
  /**
   * @generated from field: repeated ga.config_manager.providersconfig.ProviderModel models = 1;
   */
  models: ProviderModel[];
};

/**
 * Describes the message ga.config_manager.providersconfig.UpsertModelRequest.
 * Use `create(UpsertModelRequestSchema)` to create a new message.
 */
export const UpsertModelRequestSchema: GenMessage<UpsertModelRequest> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_providersconfig_providers_config, 8);

/**
 * @generated from message ga.config_manager.providersconfig.UpsertModelResponse
 */
export type UpsertModelResponse = Message<"ga.config_manager.providersconfig.UpsertModelResponse"> & {
};

/**
 * Describes the message ga.config_manager.providersconfig.UpsertModelResponse.
 * Use `create(UpsertModelResponseSchema)` to create a new message.
 */
export const UpsertModelResponseSchema: GenMessage<UpsertModelResponse> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_providersconfig_providers_config, 9);

/**
 * @generated from message ga.config_manager.providersconfig.DeleteModelRequest
 */
export type DeleteModelRequest = Message<"ga.config_manager.providersconfig.DeleteModelRequest"> & {
  /**
   * @generated from field: string branch = 1;
   */
  branch: string;

  /**
   * @generated from field: string provider = 2;
   */
  provider: string;

  /**
   * @generated from field: ga.config_manager.providersconfig.SettingTable table = 3;
   */
  table: SettingTable;

  /**
   * @generated from field: repeated string setting = 4;
   */
  setting: string[];
};

/**
 * Describes the message ga.config_manager.providersconfig.DeleteModelRequest.
 * Use `create(DeleteModelRequestSchema)` to create a new message.
 */
export const DeleteModelRequestSchema: GenMessage<DeleteModelRequest> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_providersconfig_providers_config, 10);

/**
 * @generated from message ga.config_manager.providersconfig.DeleteModelResponse
 */
export type DeleteModelResponse = Message<"ga.config_manager.providersconfig.DeleteModelResponse"> & {
};

/**
 * Describes the message ga.config_manager.providersconfig.DeleteModelResponse.
 * Use `create(DeleteModelResponseSchema)` to create a new message.
 */
export const DeleteModelResponseSchema: GenMessage<DeleteModelResponse> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_providersconfig_providers_config, 11);

/**
 * @generated from message ga.config_manager.providersconfig.MergeModelRequest
 */
export type MergeModelRequest = Message<"ga.config_manager.providersconfig.MergeModelRequest"> & {
  /**
   * @generated from field: string from_branch = 1;
   */
  fromBranch: string;

  /**
   * @generated from field: string to_branch = 2;
   */
  toBranch: string;
};

/**
 * Describes the message ga.config_manager.providersconfig.MergeModelRequest.
 * Use `create(MergeModelRequestSchema)` to create a new message.
 */
export const MergeModelRequestSchema: GenMessage<MergeModelRequest> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_providersconfig_providers_config, 12);

/**
 * @generated from message ga.config_manager.providersconfig.MergeModelResponse
 */
export type MergeModelResponse = Message<"ga.config_manager.providersconfig.MergeModelResponse"> & {
  /**
   * @generated from field: repeated ga.config_manager.providersconfig.MergeModelResponse.Delta deltas = 1;
   */
  deltas: MergeModelResponse_Delta[];
};

/**
 * Describes the message ga.config_manager.providersconfig.MergeModelResponse.
 * Use `create(MergeModelResponseSchema)` to create a new message.
 */
export const MergeModelResponseSchema: GenMessage<MergeModelResponse> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_providersconfig_providers_config, 13);

/**
 * @generated from message ga.config_manager.providersconfig.MergeModelResponse.Delta
 */
export type MergeModelResponse_Delta = Message<"ga.config_manager.providersconfig.MergeModelResponse.Delta"> & {
  /**
   * @generated from field: string provider = 1;
   */
  provider: string;

  /**
   * @generated from field: ga.config_manager.providersconfig.SettingTable table = 2;
   */
  table: SettingTable;

  /**
   * @generated from field: string setting = 3;
   */
  setting: string;

  /**
   * @generated from field: string value_from = 4;
   */
  valueFrom: string;

  /**
   * @generated from field: string value_to = 5;
   */
  valueTo: string;
};

/**
 * Describes the message ga.config_manager.providersconfig.MergeModelResponse.Delta.
 * Use `create(MergeModelResponse_DeltaSchema)` to create a new message.
 */
export const MergeModelResponse_DeltaSchema: GenMessage<MergeModelResponse_Delta> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_providersconfig_providers_config, 13, 0);

/**
 * @generated from message ga.config_manager.providersconfig.SettingsBranchesRequest
 */
export type SettingsBranchesRequest = Message<"ga.config_manager.providersconfig.SettingsBranchesRequest"> & {
};

/**
 * Describes the message ga.config_manager.providersconfig.SettingsBranchesRequest.
 * Use `create(SettingsBranchesRequestSchema)` to create a new message.
 */
export const SettingsBranchesRequestSchema: GenMessage<SettingsBranchesRequest> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_providersconfig_providers_config, 14);

/**
 * @generated from message ga.config_manager.providersconfig.SettingsBranchesResponse
 */
export type SettingsBranchesResponse = Message<"ga.config_manager.providersconfig.SettingsBranchesResponse"> & {
  /**
   * @generated from field: map<string, ga.config_manager.providersconfig.SettingsBranchesResponse.BranchInfo> branches = 1;
   */
  branches: { [key: string]: SettingsBranchesResponse_BranchInfo };

  /**
   * @generated from field: map<string, ga.config_manager.providersconfig.SettingsBranchesResponse.ProviderInfo> providers = 2;
   */
  providers: { [key: string]: SettingsBranchesResponse_ProviderInfo };
};

/**
 * Describes the message ga.config_manager.providersconfig.SettingsBranchesResponse.
 * Use `create(SettingsBranchesResponseSchema)` to create a new message.
 */
export const SettingsBranchesResponseSchema: GenMessage<SettingsBranchesResponse> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_providersconfig_providers_config, 15);

/**
 * @generated from message ga.config_manager.providersconfig.SettingsBranchesResponse.BranchInfo
 */
export type SettingsBranchesResponse_BranchInfo = Message<"ga.config_manager.providersconfig.SettingsBranchesResponse.BranchInfo"> & {
  /**
   * @generated from field: repeated string tags = 1;
   */
  tags: string[];
};

/**
 * Describes the message ga.config_manager.providersconfig.SettingsBranchesResponse.BranchInfo.
 * Use `create(SettingsBranchesResponse_BranchInfoSchema)` to create a new message.
 */
export const SettingsBranchesResponse_BranchInfoSchema: GenMessage<SettingsBranchesResponse_BranchInfo> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_providersconfig_providers_config, 15, 0);

/**
 * @generated from message ga.config_manager.providersconfig.SettingsBranchesResponse.ProviderInfo
 */
export type SettingsBranchesResponse_ProviderInfo = Message<"ga.config_manager.providersconfig.SettingsBranchesResponse.ProviderInfo"> & {
  /**
   * @generated from field: repeated string envs = 1;
   */
  envs: string[];

  /**
   * @generated from field: bool is_universal = 2;
   */
  isUniversal: boolean;
};

/**
 * Describes the message ga.config_manager.providersconfig.SettingsBranchesResponse.ProviderInfo.
 * Use `create(SettingsBranchesResponse_ProviderInfoSchema)` to create a new message.
 */
export const SettingsBranchesResponse_ProviderInfoSchema: GenMessage<SettingsBranchesResponse_ProviderInfo> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_providersconfig_providers_config, 15, 1);

/**
 * @generated from message ga.config_manager.providersconfig.SettingsRequest
 */
export type SettingsRequest = Message<"ga.config_manager.providersconfig.SettingsRequest"> & {
  /**
   * require
   *
   * @generated from field: string env = 1;
   */
  env: string;

  /**
   * require
   *
   * @generated from field: string branch = 2;
   */
  branch: string;

  /**
   * @generated from field: string model_branch = 3;
   */
  modelBranch: string;

  /**
   * optional filter
   *
   * @generated from field: string provider = 4;
   */
  provider: string;
};

/**
 * Describes the message ga.config_manager.providersconfig.SettingsRequest.
 * Use `create(SettingsRequestSchema)` to create a new message.
 */
export const SettingsRequestSchema: GenMessage<SettingsRequest> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_providersconfig_providers_config, 16);

/**
 * @generated from message ga.config_manager.providersconfig.SettingsResponse
 */
export type SettingsResponse = Message<"ga.config_manager.providersconfig.SettingsResponse"> & {
  /**
   * @generated from field: repeated ga.config_manager.providersconfig.ProviderModel models = 1;
   */
  models: ProviderModel[];

  /**
   * @generated from field: repeated ga.config_manager.providersconfig.ProviderSetting providers = 2;
   */
  providers: ProviderSetting[];

  /**
   * @generated from field: repeated ga.config_manager.providersconfig.BrandSetting brands = 3;
   */
  brands: BrandSetting[];

  /**
   * @generated from field: repeated ga.config_manager.providersconfig.CasinoSetting casinos = 4;
   */
  casinos: CasinoSetting[];

  /**
   * @generated from field: repeated ga.config_manager.providersconfig.FilterSetting filters = 5;
   */
  filters: FilterSetting[];
};

/**
 * Describes the message ga.config_manager.providersconfig.SettingsResponse.
 * Use `create(SettingsResponseSchema)` to create a new message.
 */
export const SettingsResponseSchema: GenMessage<SettingsResponse> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_providersconfig_providers_config, 17);

/**
 * @generated from message ga.config_manager.providersconfig.CopySettingsBranchRequest
 */
export type CopySettingsBranchRequest = Message<"ga.config_manager.providersconfig.CopySettingsBranchRequest"> & {
  /**
   * @generated from field: string from_branch = 1;
   */
  fromBranch: string;

  /**
   * @generated from field: string to_branch = 2;
   */
  toBranch: string;
};

/**
 * Describes the message ga.config_manager.providersconfig.CopySettingsBranchRequest.
 * Use `create(CopySettingsBranchRequestSchema)` to create a new message.
 */
export const CopySettingsBranchRequestSchema: GenMessage<CopySettingsBranchRequest> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_providersconfig_providers_config, 18);

/**
 * @generated from message ga.config_manager.providersconfig.CopySettingsBranchResponse
 */
export type CopySettingsBranchResponse = Message<"ga.config_manager.providersconfig.CopySettingsBranchResponse"> & {
};

/**
 * Describes the message ga.config_manager.providersconfig.CopySettingsBranchResponse.
 * Use `create(CopySettingsBranchResponseSchema)` to create a new message.
 */
export const CopySettingsBranchResponseSchema: GenMessage<CopySettingsBranchResponse> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_providersconfig_providers_config, 19);

/**
 * Mirrors provider_global_settings row.
 *
 * @generated from message ga.config_manager.providersconfig.ProviderSetting
 */
export type ProviderSetting = Message<"ga.config_manager.providersconfig.ProviderSetting"> & {
  /**
   * @generated from field: string env = 1;
   */
  env: string;

  /**
   * @generated from field: string branch = 2;
   */
  branch: string;

  /**
   * @generated from field: string provider = 3;
   */
  provider: string;

  /**
   * @generated from field: string setting = 4;
   */
  setting: string;

  /**
   * @generated from field: ga.config_manager.providersconfig.SettingType setting_type = 5;
   */
  settingType: SettingType;

  /**
   * @generated from field: string value = 6;
   */
  value: string;

  /**
   * @generated from field: string vault_path = 7;
   */
  vaultPath: string;

  /**
   * @generated from field: string vault_key = 8;
   */
  vaultKey: string;

  /**
   * @generated from field: ga.config_manager.providersconfig.Action action = 16;
   */
  action: Action;
};

/**
 * Describes the message ga.config_manager.providersconfig.ProviderSetting.
 * Use `create(ProviderSettingSchema)` to create a new message.
 */
export const ProviderSettingSchema: GenMessage<ProviderSetting> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_providersconfig_providers_config, 20);

/**
 * Mirrors provider_brand_settings row.
 *
 * @generated from message ga.config_manager.providersconfig.BrandSetting
 */
export type BrandSetting = Message<"ga.config_manager.providersconfig.BrandSetting"> & {
  /**
   * @generated from field: string env = 1;
   */
  env: string;

  /**
   * @generated from field: string branch = 2;
   */
  branch: string;

  /**
   * @generated from field: string provider = 3;
   */
  provider: string;

  /**
   * @generated from field: string brand = 4;
   */
  brand: string;

  /**
   * @generated from field: string setting = 5;
   */
  setting: string;

  /**
   * @generated from field: ga.config_manager.providersconfig.SettingType setting_type = 6;
   */
  settingType: SettingType;

  /**
   * @generated from field: string value = 7;
   */
  value: string;

  /**
   * @generated from field: string vault_path = 8;
   */
  vaultPath: string;

  /**
   * @generated from field: string vault_key = 9;
   */
  vaultKey: string;

  /**
   * @generated from field: ga.config_manager.providersconfig.Action action = 16;
   */
  action: Action;
};

/**
 * Describes the message ga.config_manager.providersconfig.BrandSetting.
 * Use `create(BrandSettingSchema)` to create a new message.
 */
export const BrandSettingSchema: GenMessage<BrandSetting> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_providersconfig_providers_config, 21);

/**
 * Mirrors provider_casino_settings row.
 *
 * @generated from message ga.config_manager.providersconfig.CasinoSetting
 */
export type CasinoSetting = Message<"ga.config_manager.providersconfig.CasinoSetting"> & {
  /**
   * @generated from field: string env = 1;
   */
  env: string;

  /**
   * @generated from field: string branch = 2;
   */
  branch: string;

  /**
   * @generated from field: string provider = 3;
   */
  provider: string;

  /**
   * @generated from field: string casino = 4;
   */
  casino: string;

  /**
   * @generated from field: string setting = 5;
   */
  setting: string;

  /**
   * @generated from field: ga.config_manager.providersconfig.SettingType setting_type = 6;
   */
  settingType: SettingType;

  /**
   * @generated from field: string value = 7;
   */
  value: string;

  /**
   * @generated from field: string vault_path = 8;
   */
  vaultPath: string;

  /**
   * @generated from field: string vault_key = 9;
   */
  vaultKey: string;

  /**
   * @generated from field: ga.config_manager.providersconfig.Action action = 16;
   */
  action: Action;
};

/**
 * Describes the message ga.config_manager.providersconfig.CasinoSetting.
 * Use `create(CasinoSettingSchema)` to create a new message.
 */
export const CasinoSettingSchema: GenMessage<CasinoSetting> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_providersconfig_providers_config, 22);

/**
 * Mirrors provider_filter_settings row.
 *
 * @generated from message ga.config_manager.providersconfig.FilterSetting
 */
export type FilterSetting = Message<"ga.config_manager.providersconfig.FilterSetting"> & {
  /**
   * @generated from field: string env = 1;
   */
  env: string;

  /**
   * @generated from field: string branch = 2;
   */
  branch: string;

  /**
   * @generated from field: string provider = 3;
   */
  provider: string;

  /**
   * @generated from field: ga.config_manager.providersconfig.FilterType type = 4;
   */
  type: FilterType;

  /**
   * @generated from field: string setting = 5;
   */
  setting: string;

  /**
   * @generated from field: repeated string values = 6;
   */
  values: string[];

  /**
   * @generated from field: ga.config_manager.providersconfig.Action action = 16;
   */
  action: Action;
};

/**
 * Describes the message ga.config_manager.providersconfig.FilterSetting.
 * Use `create(FilterSettingSchema)` to create a new message.
 */
export const FilterSettingSchema: GenMessage<FilterSetting> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_providersconfig_providers_config, 23);

/**
 * @generated from message ga.config_manager.providersconfig.UpsertSettingsRequest
 */
export type UpsertSettingsRequest = Message<"ga.config_manager.providersconfig.UpsertSettingsRequest"> & {
  /**
   * @generated from field: repeated ga.config_manager.providersconfig.ProviderSetting providers = 1;
   */
  providers: ProviderSetting[];

  /**
   * @generated from field: repeated ga.config_manager.providersconfig.BrandSetting brands = 2;
   */
  brands: BrandSetting[];

  /**
   * @generated from field: repeated ga.config_manager.providersconfig.CasinoSetting casinos = 3;
   */
  casinos: CasinoSetting[];

  /**
   * @generated from field: repeated ga.config_manager.providersconfig.FilterSetting filters = 4;
   */
  filters: FilterSetting[];
};

/**
 * Describes the message ga.config_manager.providersconfig.UpsertSettingsRequest.
 * Use `create(UpsertSettingsRequestSchema)` to create a new message.
 */
export const UpsertSettingsRequestSchema: GenMessage<UpsertSettingsRequest> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_providersconfig_providers_config, 24);

/**
 * @generated from message ga.config_manager.providersconfig.UpsertSettingsResponse
 */
export type UpsertSettingsResponse = Message<"ga.config_manager.providersconfig.UpsertSettingsResponse"> & {
};

/**
 * Describes the message ga.config_manager.providersconfig.UpsertSettingsResponse.
 * Use `create(UpsertSettingsResponseSchema)` to create a new message.
 */
export const UpsertSettingsResponseSchema: GenMessage<UpsertSettingsResponse> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_providersconfig_providers_config, 25);

/**
 * @generated from message ga.config_manager.providersconfig.DeleteSettingsRequest
 */
export type DeleteSettingsRequest = Message<"ga.config_manager.providersconfig.DeleteSettingsRequest"> & {
  /**
   * @generated from field: repeated ga.config_manager.providersconfig.ProviderSetting providers = 1;
   */
  providers: ProviderSetting[];

  /**
   * @generated from field: repeated ga.config_manager.providersconfig.BrandSetting brands = 2;
   */
  brands: BrandSetting[];

  /**
   * @generated from field: repeated ga.config_manager.providersconfig.CasinoSetting casinos = 3;
   */
  casinos: CasinoSetting[];

  /**
   * @generated from field: repeated ga.config_manager.providersconfig.FilterSetting filters = 4;
   */
  filters: FilterSetting[];
};

/**
 * Describes the message ga.config_manager.providersconfig.DeleteSettingsRequest.
 * Use `create(DeleteSettingsRequestSchema)` to create a new message.
 */
export const DeleteSettingsRequestSchema: GenMessage<DeleteSettingsRequest> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_providersconfig_providers_config, 26);

/**
 * @generated from message ga.config_manager.providersconfig.DeleteSettingsResponse
 */
export type DeleteSettingsResponse = Message<"ga.config_manager.providersconfig.DeleteSettingsResponse"> & {
};

/**
 * Describes the message ga.config_manager.providersconfig.DeleteSettingsResponse.
 * Use `create(DeleteSettingsResponseSchema)` to create a new message.
 */
export const DeleteSettingsResponseSchema: GenMessage<DeleteSettingsResponse> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_providersconfig_providers_config, 27);

/**
 * @generated from message ga.config_manager.providersconfig.MergeSettingsRequest
 */
export type MergeSettingsRequest = Message<"ga.config_manager.providersconfig.MergeSettingsRequest"> & {
  /**
   * @generated from field: string from_branch = 1;
   */
  fromBranch: string;

  /**
   * @generated from field: string to_branch = 2;
   */
  toBranch: string;
};

/**
 * Describes the message ga.config_manager.providersconfig.MergeSettingsRequest.
 * Use `create(MergeSettingsRequestSchema)` to create a new message.
 */
export const MergeSettingsRequestSchema: GenMessage<MergeSettingsRequest> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_providersconfig_providers_config, 28);

/**
 * @generated from message ga.config_manager.providersconfig.MergeSettingsResponse
 */
export type MergeSettingsResponse = Message<"ga.config_manager.providersconfig.MergeSettingsResponse"> & {
  /**
   * @generated from field: repeated ga.config_manager.providersconfig.MergeSettingsResponse.Delta deltas = 1;
   */
  deltas: MergeSettingsResponse_Delta[];

  /**
   * @generated from field: string git_branch = 2;
   */
  gitBranch: string;

  /**
   * @generated from field: string git_mr_link = 3;
   */
  gitMrLink: string;
};

/**
 * Describes the message ga.config_manager.providersconfig.MergeSettingsResponse.
 * Use `create(MergeSettingsResponseSchema)` to create a new message.
 */
export const MergeSettingsResponseSchema: GenMessage<MergeSettingsResponse> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_providersconfig_providers_config, 29);

/**
 * @generated from message ga.config_manager.providersconfig.MergeSettingsResponse.Delta
 */
export type MergeSettingsResponse_Delta = Message<"ga.config_manager.providersconfig.MergeSettingsResponse.Delta"> & {
  /**
   * @generated from field: string provider = 1;
   */
  provider: string;

  /**
   * @generated from field: string env = 2;
   */
  env: string;

  /**
   * @generated from field: ga.config_manager.providersconfig.SettingTable table = 3;
   */
  table: SettingTable;

  /**
   * set when table == TABLE_BRAND
   *
   * @generated from field: string brand = 4;
   */
  brand: string;

  /**
   * set when table == TABLE_CASINO
   *
   * @generated from field: string casino = 5;
   */
  casino: string;

  /**
   * @generated from field: string setting = 6;
   */
  setting: string;

  /**
   * @generated from field: string value_from = 7;
   */
  valueFrom: string;

  /**
   * @generated from field: string value_to = 8;
   */
  valueTo: string;
};

/**
 * Describes the message ga.config_manager.providersconfig.MergeSettingsResponse.Delta.
 * Use `create(MergeSettingsResponse_DeltaSchema)` to create a new message.
 */
export const MergeSettingsResponse_DeltaSchema: GenMessage<MergeSettingsResponse_Delta> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_providersconfig_providers_config, 29, 0);

/**
 * @generated from message ga.config_manager.providersconfig.ValidateSettingsBranchRequest
 */
export type ValidateSettingsBranchRequest = Message<"ga.config_manager.providersconfig.ValidateSettingsBranchRequest"> & {
  /**
   * @generated from field: string env = 1;
   */
  env: string;

  /**
   * @generated from field: string branch = 2;
   */
  branch: string;
};

/**
 * Describes the message ga.config_manager.providersconfig.ValidateSettingsBranchRequest.
 * Use `create(ValidateSettingsBranchRequestSchema)` to create a new message.
 */
export const ValidateSettingsBranchRequestSchema: GenMessage<ValidateSettingsBranchRequest> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_providersconfig_providers_config, 30);

/**
 * @generated from message ga.config_manager.providersconfig.ValidateSettingsBranchResponse
 */
export type ValidateSettingsBranchResponse = Message<"ga.config_manager.providersconfig.ValidateSettingsBranchResponse"> & {
  /**
   * @generated from field: ga.config_manager.providersconfig.Result res = 1;
   */
  res?: Result;
};

/**
 * Describes the message ga.config_manager.providersconfig.ValidateSettingsBranchResponse.
 * Use `create(ValidateSettingsBranchResponseSchema)` to create a new message.
 */
export const ValidateSettingsBranchResponseSchema: GenMessage<ValidateSettingsBranchResponse> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_providersconfig_providers_config, 31);

/**
 * @generated from message ga.config_manager.providersconfig.ImportRequest
 */
export type ImportRequest = Message<"ga.config_manager.providersconfig.ImportRequest"> & {
  /**
   * @generated from field: string from_git_branch = 1;
   */
  fromGitBranch: string;

  /**
   * @generated from field: string to_branch = 2;
   */
  toBranch: string;
};

/**
 * Describes the message ga.config_manager.providersconfig.ImportRequest.
 * Use `create(ImportRequestSchema)` to create a new message.
 */
export const ImportRequestSchema: GenMessage<ImportRequest> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_providersconfig_providers_config, 32);

/**
 * @generated from message ga.config_manager.providersconfig.ImportResponse
 */
export type ImportResponse = Message<"ga.config_manager.providersconfig.ImportResponse"> & {
  /**
   * @generated from field: ga.config_manager.providersconfig.Result res = 1;
   */
  res?: Result;
};

/**
 * Describes the message ga.config_manager.providersconfig.ImportResponse.
 * Use `create(ImportResponseSchema)` to create a new message.
 */
export const ImportResponseSchema: GenMessage<ImportResponse> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_providersconfig_providers_config, 33);

/**
 * @generated from message ga.config_manager.providersconfig.ExportRequest
 */
export type ExportRequest = Message<"ga.config_manager.providersconfig.ExportRequest"> & {
  /**
   * @generated from field: string from_branch = 2;
   */
  fromBranch: string;
};

/**
 * Describes the message ga.config_manager.providersconfig.ExportRequest.
 * Use `create(ExportRequestSchema)` to create a new message.
 */
export const ExportRequestSchema: GenMessage<ExportRequest> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_providersconfig_providers_config, 34);

/**
 * @generated from message ga.config_manager.providersconfig.ExportResponse
 */
export type ExportResponse = Message<"ga.config_manager.providersconfig.ExportResponse"> & {
  /**
   * @generated from field: ga.config_manager.providersconfig.Result res = 1;
   */
  res?: Result;

  /**
   * @generated from field: string git_branch = 2;
   */
  gitBranch: string;

  /**
   * @generated from field: string git_mr_link = 3;
   */
  gitMrLink: string;
};

/**
 * Describes the message ga.config_manager.providersconfig.ExportResponse.
 * Use `create(ExportResponseSchema)` to create a new message.
 */
export const ExportResponseSchema: GenMessage<ExportResponse> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_providersconfig_providers_config, 35);

/**
 * @generated from message ga.config_manager.providersconfig.SecretCheckRequest
 */
export type SecretCheckRequest = Message<"ga.config_manager.providersconfig.SecretCheckRequest"> & {
  /**
   * @generated from field: string path = 1;
   */
  path: string;

  /**
   * @generated from field: string key = 2;
   */
  key: string;
};

/**
 * Describes the message ga.config_manager.providersconfig.SecretCheckRequest.
 * Use `create(SecretCheckRequestSchema)` to create a new message.
 */
export const SecretCheckRequestSchema: GenMessage<SecretCheckRequest> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_providersconfig_providers_config, 36);

/**
 * @generated from message ga.config_manager.providersconfig.SecretCheckResponse
 */
export type SecretCheckResponse = Message<"ga.config_manager.providersconfig.SecretCheckResponse"> & {
  /**
   * @generated from field: bool path_exist = 1;
   */
  pathExist: boolean;

  /**
   * @generated from field: bool key_exist = 2;
   */
  keyExist: boolean;
};

/**
 * Describes the message ga.config_manager.providersconfig.SecretCheckResponse.
 * Use `create(SecretCheckResponseSchema)` to create a new message.
 */
export const SecretCheckResponseSchema: GenMessage<SecretCheckResponse> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_providersconfig_providers_config, 37);

/**
 * @generated from message ga.config_manager.providersconfig.SecretReadRequest
 */
export type SecretReadRequest = Message<"ga.config_manager.providersconfig.SecretReadRequest"> & {
  /**
   * @generated from field: string path = 1;
   */
  path: string;

  /**
   * @generated from field: string key = 2;
   */
  key: string;
};

/**
 * Describes the message ga.config_manager.providersconfig.SecretReadRequest.
 * Use `create(SecretReadRequestSchema)` to create a new message.
 */
export const SecretReadRequestSchema: GenMessage<SecretReadRequest> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_providersconfig_providers_config, 38);

/**
 * @generated from message ga.config_manager.providersconfig.SecretReadResponse
 */
export type SecretReadResponse = Message<"ga.config_manager.providersconfig.SecretReadResponse"> & {
  /**
   * @generated from field: string value = 1;
   */
  value: string;
};

/**
 * Describes the message ga.config_manager.providersconfig.SecretReadResponse.
 * Use `create(SecretReadResponseSchema)` to create a new message.
 */
export const SecretReadResponseSchema: GenMessage<SecretReadResponse> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_providersconfig_providers_config, 39);

/**
 * @generated from message ga.config_manager.providersconfig.SecretWriteRequest
 */
export type SecretWriteRequest = Message<"ga.config_manager.providersconfig.SecretWriteRequest"> & {
  /**
   * @generated from field: string path = 1;
   */
  path: string;

  /**
   * @generated from field: string key = 2;
   */
  key: string;

  /**
   * @generated from field: string value = 3;
   */
  value: string;
};

/**
 * Describes the message ga.config_manager.providersconfig.SecretWriteRequest.
 * Use `create(SecretWriteRequestSchema)` to create a new message.
 */
export const SecretWriteRequestSchema: GenMessage<SecretWriteRequest> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_providersconfig_providers_config, 40);

/**
 * @generated from message ga.config_manager.providersconfig.SecretWriteResponse
 */
export type SecretWriteResponse = Message<"ga.config_manager.providersconfig.SecretWriteResponse"> & {
};

/**
 * Describes the message ga.config_manager.providersconfig.SecretWriteResponse.
 * Use `create(SecretWriteResponseSchema)` to create a new message.
 */
export const SecretWriteResponseSchema: GenMessage<SecretWriteResponse> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_providersconfig_providers_config, 41);

/**
 * @generated from message ga.config_manager.providersconfig.SetTagsSettingsRequest
 */
export type SetTagsSettingsRequest = Message<"ga.config_manager.providersconfig.SetTagsSettingsRequest"> & {
  /**
   * @generated from field: string branch = 1;
   */
  branch: string;

  /**
   * @generated from field: repeated string tags = 2;
   */
  tags: string[];
};

/**
 * Describes the message ga.config_manager.providersconfig.SetTagsSettingsRequest.
 * Use `create(SetTagsSettingsRequestSchema)` to create a new message.
 */
export const SetTagsSettingsRequestSchema: GenMessage<SetTagsSettingsRequest> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_providersconfig_providers_config, 42);

/**
 * @generated from message ga.config_manager.providersconfig.SetTagsSettingsResponse
 */
export type SetTagsSettingsResponse = Message<"ga.config_manager.providersconfig.SetTagsSettingsResponse"> & {
};

/**
 * Describes the message ga.config_manager.providersconfig.SetTagsSettingsResponse.
 * Use `create(SetTagsSettingsResponseSchema)` to create a new message.
 */
export const SetTagsSettingsResponseSchema: GenMessage<SetTagsSettingsResponse> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_providersconfig_providers_config, 43);

/**
 * Maps to provider_setting_infos.table_name: provider/casino/brand/filter.
 *
 * @generated from enum ga.config_manager.providersconfig.SettingTable
 */
export enum SettingTable {
  /**
   * @generated from enum value: TABLE_UNKNOWN = 0;
   */
  TABLE_UNKNOWN = 0,

  /**
   * @generated from enum value: TABLE_PROVIDER = 1;
   */
  TABLE_PROVIDER = 1,

  /**
   * @generated from enum value: TABLE_CASINO = 2;
   */
  TABLE_CASINO = 2,

  /**
   * @generated from enum value: TABLE_BRAND = 3;
   */
  TABLE_BRAND = 3,

  /**
   * @generated from enum value: TABLE_FILTER = 4;
   */
  TABLE_FILTER = 4,
}

/**
 * Describes the enum ga.config_manager.providersconfig.SettingTable.
 */
export const SettingTableSchema: GenEnum<SettingTable> = /*@__PURE__*/
  enumDesc(file_ga_config_manager_providersconfig_providers_config, 0);

/**
 * @generated from enum ga.config_manager.providersconfig.SettingType
 */
export enum SettingType {
  /**
   * @generated from enum value: UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * @generated from enum value: SECRET = 1;
   */
  SECRET = 1,

  /**
   * @generated from enum value: ARRAY = 2;
   */
  ARRAY = 2,

  /**
   * @generated from enum value: STRING = 3;
   */
  STRING = 3,

  /**
   * @generated from enum value: FLOAT = 4;
   */
  FLOAT = 4,

  /**
   * @generated from enum value: INT = 5;
   */
  INT = 5,

  /**
   * @generated from enum value: BOOL = 6;
   */
  BOOL = 6,
}

/**
 * Describes the enum ga.config_manager.providersconfig.SettingType.
 */
export const SettingTypeSchema: GenEnum<SettingType> = /*@__PURE__*/
  enumDesc(file_ga_config_manager_providersconfig_providers_config, 1);

/**
 * Filter category for provider_filter_settings.type.
 *
 * @generated from enum ga.config_manager.providersconfig.FilterType
 */
export enum FilterType {
  /**
   * @generated from enum value: FILTER_UNKNOWN = 0;
   */
  FILTER_UNKNOWN = 0,

  /**
   * @generated from enum value: FILTER_IPS_WHITELIST = 1;
   */
  FILTER_IPS_WHITELIST = 1,

  /**
   * @generated from enum value: FILTER_CURRENCIES_ALLOWED_DEFAULT = 2;
   */
  FILTER_CURRENCIES_ALLOWED_DEFAULT = 2,

  /**
   * @generated from enum value: FILTER_CURRENCIES_ALLOWED_BRAND = 3;
   */
  FILTER_CURRENCIES_ALLOWED_BRAND = 3,

  /**
   * @generated from enum value: FILTER_CURRENCIES_ALLOWED_PRODUCER = 4;
   */
  FILTER_CURRENCIES_ALLOWED_PRODUCER = 4,

  /**
   * @generated from enum value: FILTER_TERRITORIES_RESTRICTED_DEFAULT = 5;
   */
  FILTER_TERRITORIES_RESTRICTED_DEFAULT = 5,

  /**
   * @generated from enum value: FILTER_TERRITORIES_RESTRICTED_BRAND = 6;
   */
  FILTER_TERRITORIES_RESTRICTED_BRAND = 6,

  /**
   * @generated from enum value: FILTER_TERRITORIES_RESTRICTED_PRODUCER = 7;
   */
  FILTER_TERRITORIES_RESTRICTED_PRODUCER = 7,
}

/**
 * Describes the enum ga.config_manager.providersconfig.FilterType.
 */
export const FilterTypeSchema: GenEnum<FilterType> = /*@__PURE__*/
  enumDesc(file_ga_config_manager_providersconfig_providers_config, 2);

/**
 * @generated from enum ga.config_manager.providersconfig.Action
 */
export enum Action {
  /**
   * @generated from enum value: ACTION_NO_OR_UPSET = 0;
   */
  NO_OR_UPSET = 0,

  /**
   * @generated from enum value: ACTION_DELETE = 1;
   */
  DELETE = 1,
}

/**
 * Describes the enum ga.config_manager.providersconfig.Action.
 */
export const ActionSchema: GenEnum<Action> = /*@__PURE__*/
  enumDesc(file_ga_config_manager_providersconfig_providers_config, 3);

/**
 * @generated from service ga.config_manager.providersconfig.ProvidersConfigService
 */
export const ProvidersConfigService: GenService<{
  /**
   * @generated from rpc ga.config_manager.providersconfig.ProvidersConfigService.ModelsBranches
   */
  modelsBranches: {
    methodKind: "unary";
    input: typeof ModelsBranchesRequestSchema;
    output: typeof ModelsBranchesResponseSchema;
  },
  /**
   * @generated from rpc ga.config_manager.providersconfig.ProvidersConfigService.Models
   */
  models: {
    methodKind: "unary";
    input: typeof ModelsRequestSchema;
    output: typeof ModelsResponseSchema;
  },
  /**
   * @generated from rpc ga.config_manager.providersconfig.ProvidersConfigService.CopyModelsBranch
   */
  copyModelsBranch: {
    methodKind: "unary";
    input: typeof CopyModelsBranchRequestSchema;
    output: typeof CopyModelsBranchResponseSchema;
  },
  /**
   * @generated from rpc ga.config_manager.providersconfig.ProvidersConfigService.UpsertModel
   */
  upsertModel: {
    methodKind: "unary";
    input: typeof UpsertModelRequestSchema;
    output: typeof UpsertModelResponseSchema;
  },
  /**
   * @generated from rpc ga.config_manager.providersconfig.ProvidersConfigService.DeleteModel
   */
  deleteModel: {
    methodKind: "unary";
    input: typeof DeleteModelRequestSchema;
    output: typeof DeleteModelResponseSchema;
  },
  /**
   * @generated from rpc ga.config_manager.providersconfig.ProvidersConfigService.MergeModelCompare
   */
  mergeModelCompare: {
    methodKind: "unary";
    input: typeof MergeModelRequestSchema;
    output: typeof MergeModelResponseSchema;
  },
  /**
   * @generated from rpc ga.config_manager.providersconfig.ProvidersConfigService.MergeModelDo
   */
  mergeModelDo: {
    methodKind: "unary";
    input: typeof MergeModelRequestSchema;
    output: typeof MergeModelResponseSchema;
  },
  /**
   * @generated from rpc ga.config_manager.providersconfig.ProvidersConfigService.ImportModels
   */
  importModels: {
    methodKind: "unary";
    input: typeof ImportRequestSchema;
    output: typeof ImportResponseSchema;
  },
  /**
   * @generated from rpc ga.config_manager.providersconfig.ProvidersConfigService.ExportModels
   */
  exportModels: {
    methodKind: "unary";
    input: typeof ExportRequestSchema;
    output: typeof ExportResponseSchema;
  },
  /**
   * @generated from rpc ga.config_manager.providersconfig.ProvidersConfigService.SettingsBranches
   */
  settingsBranches: {
    methodKind: "unary";
    input: typeof SettingsBranchesRequestSchema;
    output: typeof SettingsBranchesResponseSchema;
  },
  /**
   * @generated from rpc ga.config_manager.providersconfig.ProvidersConfigService.Settings
   */
  settings: {
    methodKind: "unary";
    input: typeof SettingsRequestSchema;
    output: typeof SettingsResponseSchema;
  },
  /**
   * @generated from rpc ga.config_manager.providersconfig.ProvidersConfigService.CopySettingsBranch
   */
  copySettingsBranch: {
    methodKind: "unary";
    input: typeof CopySettingsBranchRequestSchema;
    output: typeof CopySettingsBranchResponseSchema;
  },
  /**
   * @generated from rpc ga.config_manager.providersconfig.ProvidersConfigService.UpsertSettings
   */
  upsertSettings: {
    methodKind: "unary";
    input: typeof UpsertSettingsRequestSchema;
    output: typeof UpsertSettingsResponseSchema;
  },
  /**
   * @generated from rpc ga.config_manager.providersconfig.ProvidersConfigService.DeleteSettings
   */
  deleteSettings: {
    methodKind: "unary";
    input: typeof DeleteSettingsRequestSchema;
    output: typeof DeleteSettingsResponseSchema;
  },
  /**
   * @generated from rpc ga.config_manager.providersconfig.ProvidersConfigService.MergeSettingsCompare
   */
  mergeSettingsCompare: {
    methodKind: "unary";
    input: typeof MergeSettingsRequestSchema;
    output: typeof MergeSettingsResponseSchema;
  },
  /**
   * @generated from rpc ga.config_manager.providersconfig.ProvidersConfigService.MergeSettingsDo
   */
  mergeSettingsDo: {
    methodKind: "unary";
    input: typeof MergeSettingsRequestSchema;
    output: typeof MergeSettingsResponseSchema;
  },
  /**
   * @generated from rpc ga.config_manager.providersconfig.ProvidersConfigService.ValidateSettingsBranch
   */
  validateSettingsBranch: {
    methodKind: "unary";
    input: typeof ValidateSettingsBranchRequestSchema;
    output: typeof ValidateSettingsBranchResponseSchema;
  },
  /**
   * @generated from rpc ga.config_manager.providersconfig.ProvidersConfigService.ImportSettings
   */
  importSettings: {
    methodKind: "unary";
    input: typeof ImportRequestSchema;
    output: typeof ImportResponseSchema;
  },
  /**
   * @generated from rpc ga.config_manager.providersconfig.ProvidersConfigService.ExportSettings
   */
  exportSettings: {
    methodKind: "unary";
    input: typeof ExportRequestSchema;
    output: typeof ExportResponseSchema;
  },
  /**
   * @generated from rpc ga.config_manager.providersconfig.ProvidersConfigService.SetTagsSettings
   */
  setTagsSettings: {
    methodKind: "unary";
    input: typeof SetTagsSettingsRequestSchema;
    output: typeof SetTagsSettingsResponseSchema;
  },
  /**
   * @generated from rpc ga.config_manager.providersconfig.ProvidersConfigService.SecretCheck
   */
  secretCheck: {
    methodKind: "unary";
    input: typeof SecretCheckRequestSchema;
    output: typeof SecretCheckResponseSchema;
  },
  /**
   * @generated from rpc ga.config_manager.providersconfig.ProvidersConfigService.SecretCheckAndCreate
   */
  secretCheckAndCreate: {
    methodKind: "unary";
    input: typeof SecretCheckRequestSchema;
    output: typeof SecretCheckResponseSchema;
  },
  /**
   * @generated from rpc ga.config_manager.providersconfig.ProvidersConfigService.SecretRead
   */
  secretRead: {
    methodKind: "unary";
    input: typeof SecretReadRequestSchema;
    output: typeof SecretReadResponseSchema;
  },
  /**
   * @generated from rpc ga.config_manager.providersconfig.ProvidersConfigService.SecretWrite
   */
  secretWrite: {
    methodKind: "unary";
    input: typeof SecretWriteRequestSchema;
    output: typeof SecretWriteResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_ga_config_manager_providersconfig_providers_config, 0);

